import React from "react";
import Squares from '../Squares/Squares';
import ProfileCard from './ProfileCard';
import { Container, Row, Col } from "react-bootstrap";
import Type from "./Type";
import { CgGitFork } from "react-icons/cg";
import { AiFillStar } from "react-icons/ai";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";




function Home() {
  //Work Status
  const workStatus = "Open to Opportunities";
  //Tech Stack
  const techStack = ["Java", "Python", "JavaScript", "React.js", "Node.js", "Git", "SQL", "HTML", "CSS", "REST APIs", "Agile Methodologies", "Problem Solving", "Critical Thinking", "Communication Skills","Microsoft Power Plartform"];
  //projects
  const projects = [
    {
      title: "Sustainable Waste Management API",
      description: "A Spring Boot Restful API that helps manage waste effectively",
      tech: ["Java", "Spring-boot", "Restful Api", "swagger-ui"],
      link: "#"
    },
    {
      title: "Random Name API",
      description: "A tool that generates random names based on different criteria",
      tech: ["Python", "fastapi", "Swagger-ui"],
      link: "#"
    },
    {
      title: "Portfolio Website",
      description: "Responsive portfolio built with HTML and CSS",
      tech: ["HTML", "CSS", "JavaScript"],
      link: "#"
    }
  ];
  //Stats
  // const stats = [
  //   { label: "Projects Completed", value: "15+" },
  //   { label: "Years Experience", value: "3+" },
  //   { label: "Technologies", value: "10+" },
  //   { label: "Happy Clients", value: "8+" }
  // ];
  //Skills/Values Section
  const coreValues = [
    {
      icon: "🖇️",
      title: "Innovation Mindset",
      content: "Constantly exploring new technologies and creative solutions to solve complex problems. Passionate about turning ideas into functional, user-friendly applications."
    },
    {
      icon: "🖇️",
      title: "Growth-Oriented",
      content: "Committed to continuous learning and professional development. Embracing challenges as opportunities to expand technical skills and industry knowledge."
    },
    {
      icon: "🖇️",
      title: "Collaborative Spirit",
      content: "Strong believer in teamwork and knowledge sharing. Eager to contribute to projects while learning from experienced developers and industry professionals."
    }
  ];



  return (
    <section className="home-section-wrapper">
      {/* Animated background */}
      <div className="background-animation">
        <Squares
          speed={0.5}
          squareSize={40}
          direction='diagonal'
          borderColor='rgba(0, 153, 112, 0.15)'
          hoverFillColor='rgba(0, 153, 112, 0.1)'
        />
      </div>

      <Container fluid className="home-section" id="home">
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              {/* Status indicator */}
              <div className="enhanced-status">
                <span className="enhanced-status-dot"></span>
                <span>{workStatus}</span>
              </div>

              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'm
                <strong className="main-name"> Zanny Athalia Maholobela</strong>
              </h1>
              <p className="main-paragraph">Based in Johannesburg with a Higher Certificate in Information Technology and currently pursuing my Bsc in Mathematics and Computer Science. I'm Extremely passionate about mixing my creative and critical problem solving interests with programming. I also adore learning a new topic and look forward to finding my place within the tech industry</p>
              <div style={{ padding: 0, textAlign: "left" }}>
                <Type />
              </div>

              {/* Action buttons */}
              <div className="enhanced-flex enhanced-flex-responsive enhanced-gap-4" style={{ marginTop: '2rem' }}>
                {/* <button className="enhanced-btn enhanced-btn-primary">
                    Get In Touch
                  </button> */}
                <button className="enhanced-btn enhanced-btn-outline" onClick={() => window.open('https://github.com/ZannyM', '_blank', 'noopener,noreferrer')}
                >
                  <CgGitFork style={{ fontSize: "1.2em" }} />{" "}
                  GITHUB
                  <AiFillStar style={{ fontSize: "1.1em" }} />
                </button>
              </div>
            </Col>

            {/* ProfileCard section */}
            <Col md={5} className="profile-card-container">
              <ProfileCard
                className=""
                handle="ZannyM"
                status="Online"
                showUserInfo={true}
                enableTilt={true}
              />
            </Col>
          </Row>

          {/* Tech Stack section */}
          <div className="enhanced-tech-stack">
            <div className="enhanced-tech-scroll">
              {[...techStack, ...techStack].map((tech, index) => (
                <div key={index} className="enhanced-tech-item">
                  <span className="enhanced-badge">
                    {tech}
                  </span>
                </div>
              ))}
            </div>
          </div>

        </Container>
      </Container>
      {/* Featured Projects Section */}
      <Container className="portfolio-section">
        <h2 className="enhanced-section-title">Featured Projects</h2>
        <p className="enhanced-section-subtitle" style={{ padding: '1rem 0' }}>
          A selection of my recent work showcasing different technologies and approaches
        </p>

        <div className="enhanced-projects">
          {projects.map((project, index) => (
            <div key={index} className="enhanced-card">

              <h3 className="enhanced-card-title">
                {project.title}
              </h3>
              <p className="enhanced-card-description">
                {project.description}
              </p>
              <div className="enhanced-flex enhanced-gap-2" style={{ flexWrap: 'wrap' }}>
                {project.tech.map((tech, i) => (
                  <span key={i} className="enhanced-badge enhanced-badge-sm">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="enhanced-text-center">
          <button className="enhanced-btn enhanced-btn-primary" onClick={() => window.location.href = '/projects'}>
            View More Projects →
          </button>
        </div>
      </Container>

      {/* Core Values & Skills */}
      <section className="recommendations-wrapper" style={{ padding: '4rem 0' }}>
        <h2 className="enhanced-section-title">Core Values & Approach</h2>
        <p className="enhanced-section-subtitle" style={{ padding: '1rem 0' }}>
          The principles and mindset that drive my development work and client relationships
        </p>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

          <div style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${window.innerWidth >= 1024 ? '3' : window.innerWidth >= 768 ? '2' : '1'}, 1fr)`,
            gap: '1.5rem'
          }}>
            {coreValues.map((value, index) => (
              <div key={index} style={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                borderRadius: '12px',
                padding: '1.5rem',
                height: 'fit-content'
              }}>
                <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>{value.icon}</div>
                <h3 style={{
                  fontSize: '1.2rem',
                  fontWeight: '600',
                  marginBottom: '1rem',
                  color: 'rgba(255, 255, 255, 0.9)'
                }}>
                  {value.title}
                </h3>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  marginBottom: '0',
                  color: 'rgba(255, 255, 255, 0.8)'
                }}>
                  {value.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Contact Navigation */}
      <section className="contact-navigation" style={{ padding: '4rem 0' }}>
        <Container>
          <Row >
            <Link
              to="/contact"
              className="contact-link"
              style={{
                display: 'flex',
                fontFamily: 'Roboto, sans-serif',
                alignItems: 'center',
                justifyContent: 'center',
                textDecoration: 'none',
                color: '#fff',
                padding: '1rem 2rem',
                borderRadius: '8px',
                fontSize: '1.2rem',
                fontWeight: '500',
                transition: 'background-color 0.3s ease',
                gap: '1rem'

              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#009970';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#fff';
              }}
            >
              CONTACT ME <FaArrowRight />
            </Link>
          </Row>
        </Container>
      </section>


    </section>
  );
}

export default Home;

